// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__yGwFY","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__6MbFJ"};